"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toImgSrc = toImgSrc;
exports.toVideoSrc = toVideoSrc;
exports.removeAlpha = removeAlpha;
function toImgSrc(media) {
    if (!media)
        return '';
    const content = media.image || media.videoThumbnailUrl;
    if (!content)
        return '';
    if (!media.cdn01)
        return content;
    if (media.videoThumbnailUrl) {
        return media.videoThumbnailUrl;
    }
    const url = media.cdn01 + content;
    return url;
}
function toVideoSrc(media) {
    if (!media)
        return '';
    if (!media.video)
        return '';
    if (!media.cdn01)
        return media.video;
    if (media.videoUrl) {
        return media.videoUrl;
    }
    const url = media.cdn01 + media.video;
    return url;
}
function hexToRgb(hex) {
    let r = 0, g = 0, b = 0;
    // 3 digits
    if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
    }
    // 6 digits
    else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
    }
    return { r, g, b };
}
function rgbToHex(r, g, b) {
    return ('#' +
        [r, g, b]
            .map((x) => x.toString(16).padStart(2, '0'))
            .join('')
            .toUpperCase());
}
function removeAlpha(hexColor, alpha = 1.0) {
    const a = Math.round(alpha * 255);
    const { r, g, b } = hexToRgb(hexColor);
    const [rb, gb, bb] = [r, g, b].map((x) => Math.round(x * (a / 255) + 255 * (1 - a / 255)));
    return rgbToHex(rb, gb, bb);
}
